var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/MyADGViolationPopup/MyADGViolationPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/MyADGViolationPopup/MyADGViolationPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/MyADGViolationPopup/MyADGViolationPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupClasses"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupClasses(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "BasePopup--transparentLeft";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"MyADGViolationPopup\">\n        <div class=\"MyADGViolationPopup-content\">\n            <div class=\"MyADGViolationPopup-contentWrapper\">\n\n                <div class=\"MyADGViolationPopup-form\">\n                    <h2 class=\"MyADGViolationPopup-formTitle\">WORKPLACE VIOLATION</h2>\n                    <div class=\"MyADGViolationPopup-formAnnotation\">If you are asked to violate the contract, or suspect a production may be in violation, let us know confidentially. You don’t have to be working on the production, and neither your name or username will be attached to this report.</div>\n\n                    <form>\n                        <div class=\"MyADGViolationPopup-formInput\">\n                            <label for=\"MyADGViolationPopup-f1\">Production Name</label>\n                            <div class=\"MyADGViolationPopup-formInputWrapper\">\n                                <input type=\"text\" name=\"production-name\" id=\"MyADGViolationPopup-f1\" value=\"\">\n                            </div>\n                        </div>\n\n                        <div class=\"MyADGViolationPopup-formInput\">\n                            <label for=\"MyADGViolationPopup-f2\">Production phone</label>\n                            <div class=\"MyADGViolationPopup-formInputWrapper\">\n                                <input type=\"text\" name=\"production-phone\" id=\"MyADGViolationPopup-f2\" value=\"\">\n                            </div>\n                        </div>\n\n                        <div class=\"MyADGViolationPopup-formInput\">\n                            <label for=\"MyADGViolationPopup-f3\">Art Department Address <span class=\"MyADGViolationPopup-formInput-label-hint\">include building, room number</span></label>\n                            <div class=\"MyADGViolationPopup-formInputWrapper\">\n                                <input type=\"text\" name=\"location\" id=\"MyADGViolationPopup-f3\" value=\"\">\n                            </div>\n                        </div>\n\n                        <div class=\"MyADGViolationPopup-formInput\">\n                            <label for=\"MyADGViolationPopup-f4\">Type of production</label>\n                            <div class=\"MyADGViolationPopup-formInputWrapper\">\n                                <input type=\"text\" name=\"type-of-production\" id=\"MyADGViolationPopup-f4\" value=\"\">\n                            </div>\n                        </div>\n\n                        <div class=\"MyADGViolationPopup-formInput\">\n                            <label for=\"MyADGViolationPopup-f5\">Explanation</label>\n                            <div class=\"MyADGViolationPopup-formInputWrapper\">\n                                <textarea name=\"explanation\" id=\"MyADGViolationPopup-f5\"></textarea>\n                            </div>\n                        </div>\n                    </form>\n\n                    <button class=\"MyADGViolationPopup-formSubmit\">Submit</button>\n                </div>\n\n                <div class=\"MyADGViolationPopup-thanks\">\n                    <h2 class=\"MyADGViolationPopup-thanksTitle\">Thanks!</h2>\n                    <div class=\"MyADGViolationPopup-thanksAnnotation\">Your confidential report has been received. Next, the executive director will determine appropriate action.</div>\n\n                    <div class=\"MyADGViolationPopup-thanksCloseWrapper\">\n                        <button class=\"MyADGViolationPopup-thanksClose\">Close</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupClasses: b_popupClasses,
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/MyADGViolationPopup/MyADGViolationPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGViolationPopup/MyADGViolationPopup.jinja
// module id = 544
// module chunks = 0